export const categories = gettext => [{
  id: 294,
  formatted: 'it-and-software',
  translated: gettext('IT & Software'),
  learnersCount: 350000,
  illustration: 'technology'
}, {
  id: 288,
  formatted: 'development',
  translated: gettext('Development'),
  learnersCount: 330000,
  illustration: 'development'
}, {
  id: 268,
  formatted: 'business',
  translated: gettext('Business'),
  learnersCount: 330000,
  illustration: 'business'
}, {
  id: 300,
  formatted: 'teaching-and-academics',
  translated: gettext('Teaching & Academics'),
  learnersCount: 270000,
  illustration: 'academics'
}, {
  id: 269,
  formatted: 'design',
  translated: gettext('Design'),
  learnersCount: 260000,
  illustration: 'design'
}, {
  id: 296,
  formatted: 'personal-development',
  translated: gettext('Personal Development'),
  learnersCount: 230000,
  illustration: 'personal-development'
}, {
  id: 290,
  formatted: 'marketing',
  translated: gettext('Marketing'),
  learnersCount: 190000,
  illustration: 'marketing'
}, {
  id: 292,
  formatted: 'office-productivity',
  translated: gettext('Office Productivity'),
  learnersCount: 180000,
  illustration: 'productivity'
}, {
  id: 328,
  formatted: 'finance-and-accounting',
  translated: gettext('Finance & Accounting'),
  learnersCount: 160000,
  illustration: 'finance'
}, {
  id: 274,
  formatted: 'lifestyle',
  translated: gettext('Lifestyle'),
  learnersCount: 150000,
  illustration: 'lifestyle'
}, {
  id: 276,
  formatted: 'health-and-fitness',
  translated: gettext('Health & Fitness'),
  learnersCount: 100000,
  illustration: 'fitness'
}, {
  id: 273,
  formatted: 'photography-and-video',
  translated: gettext('Photography & Video'),
  learnersCount: 100000,
  illustration: 'photography'
}, {
  id: 278,
  formatted: 'music',
  translated: gettext('Music'),
  learnersCount: 70000,
  illustration: 'music'
}];
export const learnerCountForCategoryByCountry = () => ({
  JP: [{
    id: 294,
    learnersCount: 350000
  }, {
    id: 288,
    learnersCount: 330000
  }, {
    id: 268,
    learnersCount: 330000
  }, {
    id: 300,
    learnersCount: 270000
  }, {
    id: 269,
    learnersCount: 260000
  }, {
    id: 296,
    learnersCount: 230000
  }, {
    id: 290,
    learnersCount: 190000
  }, {
    id: 292,
    learnersCount: 180000
  }, {
    id: 328,
    learnersCount: 160000
  }, {
    id: 274,
    learnersCount: 150000
  }, {
    id: 276,
    learnersCount: 100000
  }, {
    id: 273,
    learnersCount: 100000
  }, {
    id: 278,
    learnersCount: 70000
  }],
  IN: [{
    id: 288,
    learnersCount: 10000000
  }, {
    id: 294,
    learnersCount: 8200000
  }, {
    id: 268,
    learnersCount: 5500000
  }, {
    id: 300,
    learnersCount: 3500000
  }, {
    id: 292,
    learnersCount: 3300000
  }, {
    id: 269,
    learnersCount: 2800000
  }, {
    id: 296,
    learnersCount: 2600000
  }, {
    id: 328,
    learnersCount: 2400000
  }, {
    id: 290,
    learnersCount: 2400000
  }, {
    id: 273,
    learnersCount: 1100000
  }, {
    id: 276,
    learnersCount: 850000
  }, {
    id: 274,
    learnersCount: 750000
  }, {
    id: 278,
    learnersCount: 560000
  }],
  MX: [{
    id: 288,
    learnersCount: 870000
  }, {
    id: 294,
    learnersCount: 670000
  }, {
    id: 300,
    learnersCount: 580000
  }, {
    id: 268,
    learnersCount: 550000
  }, {
    id: 292,
    learnersCount: 490000
  }, {
    id: 269,
    learnersCount: 470000
  }, {
    id: 296,
    learnersCount: 330000
  }, {
    id: 290,
    learnersCount: 240000
  }, {
    id: 328,
    learnersCount: 210000
  }, {
    id: 273,
    learnersCount: 160000
  }, {
    id: 276,
    learnersCount: 150000
  }, {
    id: 278,
    learnersCount: 150000
  }, {
    id: 274,
    learnersCount: 145000
  }],
  DE: [{
    id: 288,
    learnersCount: 330000
  }, {
    id: 294,
    learnersCount: 250000
  }, {
    id: 268,
    learnersCount: 200000
  }, {
    id: 269,
    learnersCount: 130000
  }, {
    id: 300,
    learnersCount: 120000
  }, {
    id: 292,
    learnersCount: 110000
  }, {
    id: 296,
    learnersCount: 100000
  }, {
    id: 290,
    learnersCount: 95000
  }, {
    id: 328,
    learnersCount: 77000
  }, {
    id: 276,
    learnersCount: 55000
  }, {
    id: 273,
    learnersCount: 50000
  }, {
    id: 274,
    learnersCount: 45000
  }, {
    id: 278,
    learnersCount: 40000
  }],
  TR: [{
    id: 300,
    learnersCount: 1700000
  }, {
    id: 288,
    learnersCount: 1500000
  }, {
    id: 269,
    learnersCount: 980000
  }, {
    id: 294,
    learnersCount: 900000
  }, {
    id: 268,
    learnersCount: 740000
  }, {
    id: 292,
    learnersCount: 700000
  }, {
    id: 296,
    learnersCount: 600000
  }, {
    id: 328,
    learnersCount: 480000
  }, {
    id: 290,
    learnersCount: 450000
  }, {
    id: 273,
    learnersCount: 270000
  }, {
    id: 274,
    learnersCount: 200000
  }, {
    id: 278,
    learnersCount: 200000
  }, {
    id: 276,
    learnersCount: 200000
  }],
  BR: [{
    id: 288,
    learnersCount: 2500000
  }, {
    id: 294,
    learnersCount: 2000000
  }, {
    id: 268,
    learnersCount: 1600000
  }, {
    id: 292,
    learnersCount: 1300000
  }, {
    id: 300,
    learnersCount: 1300000
  }, {
    id: 269,
    learnersCount: 1200000
  }, {
    id: 296,
    learnersCount: 1000000
  }, {
    id: 290,
    learnersCount: 900000
  }, {
    id: 328,
    learnersCount: 600000
  }, {
    id: 274,
    learnersCount: 350000
  }, {
    id: 278,
    learnersCount: 300000
  }, {
    id: 273,
    learnersCount: 300000
  }, {
    id: 276,
    learnersCount: 200000
  }]
});
export const categoryInfo = gettext => ({
  294: {
    formatted: 'it-and-software',
    translated: gettext('IT & Software'),
    illustration: 'technology'
  },
  288: {
    formatted: 'development',
    translated: gettext('Development'),
    illustration: 'development'
  },
  268: {
    formatted: 'business',
    translated: gettext('Business'),
    illustration: 'business'
  },
  300: {
    formatted: 'teaching-and-academics',
    translated: gettext('Teaching & Academics'),
    illustration: 'academics'
  },
  269: {
    formatted: 'design',
    translated: gettext('Design'),
    illustration: 'design'
  },
  296: {
    formatted: 'personal-development',
    translated: gettext('Personal Development'),
    illustration: 'personal-development'
  },
  290: {
    formatted: 'marketing',
    translated: gettext('Marketing'),
    illustration: 'marketing'
  },
  292: {
    formatted: 'office-productivity',
    translated: gettext('Office Productivity'),
    illustration: 'productivity'
  },
  328: {
    formatted: 'finance-and-accounting',
    translated: gettext('Finance & Accounting'),
    illustration: 'finance'
  },
  274: {
    formatted: 'lifestyle',
    translated: gettext('Lifestyle'),
    illustration: 'lifestyle'
  },
  276: {
    formatted: 'health-and-fitness',
    translated: gettext('Health & Fitness'),
    illustration: 'fitness'
  },
  273: {
    formatted: 'photography-and-video',
    translated: gettext('Photography & Video'),
    illustration: 'photography'
  },
  278: {
    formatted: 'music',
    translated: gettext('Music'),
    illustration: 'music'
  }
});
export const getHeadingForCategoriesModule = (gettext, priceCountryId) => {
  const countryHeadings = {
    JP: () => gettext('Learn from popular categories in Japan'),
    IN: () => gettext('Learn from popular categories in India'),
    BR: () => gettext('Learn from popular categories in Brazil'),
    MX: () => gettext('Learn from popular categories in Mexico'),
    TR: () => gettext('Learn from popular categories in Türkiye'),
    DE: () => gettext('Learn from popular categories in Germany')
  };
  const getHeading = countryHeadings[priceCountryId];
  return getHeading ? getHeading() : '';
};
export const getHeadingForNewCategoriesModule = (gettext, priceCountryId) => {
  const countryHeadings = {
    JP: () => gettext('Popular categories in Japan'),
    IN: () => gettext('Popular categories in India'),
    BR: () => gettext('Popular categories in Brazil'),
    MX: () => gettext('Popular categories in Mexico'),
    TR: () => gettext('Popular categories in Türkiye'),
    DE: () => gettext('Popular categories in Germany')
  };
  const getHeading = countryHeadings[priceCountryId];
  return getHeading ? getHeading() : '';
};
export const categoryModuleAllowedCountries = new Set(['JP', 'IN', 'BR', 'MX', 'TR', 'DE']);
//# sourceMappingURL=constants.js.map